import React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import scrollToTop from 'decorators/scrollToTop'
import ShadowBox from 'components/ShadowBox'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import './styles.sass'

@scrollToTop
@observer
export default class ProjectTypeStep extends React.Component {
  render () {
    const { step } = this.props
    return (
      <div className="project-type-step">
        <div className="container">
          <div className="columns">
            <div className="column is-8 is-offset-2">
              {step.activate.match({
                pending: () => <ContentLoading small />,
                rejected: (err) => <ContentError error={err} />,
                resolved: () => (
                  <div className="columns project-types is-multiline">
                    {step.legends.map((legend) =>
                      <ProjectType
                        key={legend.id}
                        title={legend.name}
                        description={legend.description}
                        type={legend.id}
                        onSelect={() => step.selectType(legend)}
                      />
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// const ProjectType = ({ title, isBeta, description, type, onSelect }) => (
//   <div className="column is-full project-type animated fadeInUp is-faster is-staggered">
//     <ShadowBox className="inner" level={3} onClick={() => onSelect()}>
//       <div className={cx('type-header')}>
//         <div className="type-name">{title}</div>
//       </div>
//       <div className="type-description">
//         {description}
//       </div>
//     </ShadowBox>
//   </div>
// )

const ProjectType = ({ title, isBeta, type, onSelect }) => (
  <div className="column is-full project-type animated fadeInUp is-faster is-staggered">
    <ShadowBox level={3} className={cx('inner')} onClick={() => onSelect()}>
      {/* <img src={require(`./img/${type}.png`)} className="project-type-image" /> */}
      <div className="project-type-info has-text-centered">
        {isBeta &&
          <span className="beta-label">BETA</span>
        }
        <div className="project-type-name">{title}</div>
{/*
        <button className="button is-rounded-outline">
          Choose
        </button>
*/}
      </div>
    </ShadowBox>
  </div>
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/ProjectType/index.jsx